<template>
  <div class="app-sim-order-modal">
    <b-modal :id="'simOrderModal' + _uid"
             size="lg"
             data-qa="modal"
             :modal-class="'app-sim-order-modal'"
             :title="modalTitle"
             v-model="show_"
             @hidden="$emit('hidden', $event)"
             :hide-footer="true"
             header-bg-variant="custom"
             header-text-variant="custom"
             body-bg-variant="custom"
             body-text-variant="custom"
             footer-bg-variant="custom"
             footer-text-variant="custom"
             :ok-only="false"
    >
      <SimOrderWrapper
        @next = "next"
        :show-esim="showEsim"
        :simtype.sync = "simtype_"
      >
        <template v-for="slot in possibleChildSlotsFor('Modal')" v-slot:[`${slot.child}`]>
          <slot :name="`${slot.parent}`"></slot>
        </template>
      </SimOrderWrapper>
    </b-modal>
  </div>
</template>

<script>
import { BModal } from 'bootstrap-vue'
import syncProperty from '@/mixins/syncProperty'
import SimOrderWrapper from './SimOrderWrapper.vue'
import slotProxy from '../../../../../../mixins/slotProxy'

export default {
  name: 'SimOrderModal',
  mixins: [
    syncProperty('show', 'show_'),
    syncProperty('simtype', 'simtype_'),
    slotProxy()
  ],
  components: { BModal, SimOrderWrapper },
  methods: {
    next (value) {
      this.$emit('next', value)
    }
  },
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    modalTitle: {
      type: String,
      default: ''
    },
    slotData: {
      type: Object
    },
    showEsim: {
      type: Boolean,
      default: false
    }
  }
}

</script>
